<template>
	<div class="hero__container" :style="style">
		<slot name="header"></slot>
		<button v-if="videoId" class="hero__play-button" @click="openModal">
			{{ btnTitle }}
			<span class="hero__play-icon">
				<play />
			</span>
		</button>
		<modal-video
			v-if="videoId"
			ref="modalVideo"
			:modal-id="videoId"
			:video-id="videoId"
		></modal-video>
	</div>
</template>

<script>
import Play from '@/brands/b2c/svg/play.svg';
import { EventBus } from '../../utils/EventBus';
import ModalVideo from '../ModalVideo';

export default {
	name: 'HeroVideo',
	components: {
		Play,
		ModalVideo,
	},
	props: {
		bgColor: { type: String, required: false, default: '#1b1b1b' },
		btnTitle: { type: String, required: false, default: null },
		videoId: { type: String, required: false, default: null },
	},
	data() {
		return {};
	},
	computed: {
		style() {
			return 'background-color: ' + this.bgColor;
		},
	},

	methods: {
		openModal: function () {
			EventBus.$emit('open-modal', this.videoId);
		},
	},
};
</script>

<style lang="scss"></style>
